<div class="flex">
    <div *ngIf="image" class="col-fixed m-0 align-content-center">
        <img [src]="image" class="max-w-6rem" />
    </div>
    <div class="col m-0 p-0">
        <app-menu></app-menu>
    </div>
</div>